export default __webpack_public_path__ + "_/images/bonuses/header/cake-858b70285ed3b03c44763a94684f54404575bb01420fc41a9d007fb491f3fffc.png";